
import { call, put } from 'redux-saga/effects';
import axios from 'axios';
import { ERROR_MESSAGE } from '../../redux/modules/message/message-actions';
import { HIDE_SPINNER, SHOW_SPINNER } from '../../redux/modules/spinner/spinner';
import {
    didApiCallFailDueToUnauthorizedUser,
    didApiCallFailDueToVersionMismatch,
    getErrorMessage,
} from '../../constants/CommonUtil';
import { MISMATCH_IN_VERSION, SESSION_TIMEOUT } from '../../redux/modules/login/login-actions';
import {
    FETCH_ACCOUNT_VOUCHER_FAILURE,
    FETCH_ACCOUNT_VOUCHER_SUCCESS,
} from '../../redux/modules/accountVoucher/accountVoucher-actions';
import { addSeekDirectionAndParamsToUrlParams } from '../../constants/UrlUtil';


function* fetchDebitAndCreditLinesWorker(action) {
    try {
        const {
            api,
            page,
            size,
            seekParams,
            seekDirection,
            searchConstruct,
        } = action;
        const apiWithParams = addSeekDirectionAndParamsToUrlParams(`${api}?size=${size}`, seekDirection, seekParams);
        yield put({ type: SHOW_SPINNER, state: { canShow: true } });
        const response = yield call(axios.post, apiWithParams, searchConstruct);
        yield put({
            type: FETCH_ACCOUNT_VOUCHER_SUCCESS,
            data: {
                ...(response.data || {}),
                page,
            },
        });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    } catch (e) {
        if (didApiCallFailDueToUnauthorizedUser(e)) {
            yield put({ type: SESSION_TIMEOUT, actionToDispatchAfterLogin: action });
        } else if (didApiCallFailDueToVersionMismatch(e)) {
            yield put({ type: MISMATCH_IN_VERSION });
        } else {
            const msg = 'Account vouchers fetch failed';
            yield put({ type: ERROR_MESSAGE, message: `${msg}: ${getErrorMessage(e)}` });
        }
        yield put({ type: FETCH_ACCOUNT_VOUCHER_FAILURE, data: {} });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    }
}

export default fetchDebitAndCreditLinesWorker;
